module.exports = __webpack_public_path__ + "static/media/max3d_plus.a7b1e143.png";